import {Component, Input} from '@angular/core';
import {Address} from '../../../interface/address';

@Component({
  selector: 'app-detail-address',
  templateUrl: './detail-address.component.html',
  styleUrls: ['./detail-address.component.scss']
})
export class DetailAddressComponent {
  @Input() address: Address;
  @Input() header?: string;
}
